import { PropsWithChildren, useEffect, useState } from "react";
import MobileDeviceMessageScreen from "components/elements/Mobile/MobileDeviceMessageScreen";
import LoadingFullScreen from "components/elements/Loading/LoadingFullScreen";
import * as rdd from "react-device-detect";

export default function MobileDeviceCheck({ children }: PropsWithChildren<{}>) {
  const [mobileWarningDismissed, setMobileWarningDismissed] =
    useState<boolean>(false);

  useEffect(() => {
    setMobileWarningDismissed(
      localStorage.getItem("kfMobileWarningDismissed") === "true",
    );

    const handleMobileEnabled = () => {
      setMobileWarningDismissed(
        localStorage.getItem("kfMobileWarningDismissed") === "true",
      );
    };

    window.addEventListener("mobileWarningDismissed", handleMobileEnabled);

    return () => {
      window.removeEventListener("mobileWarningDismissed", handleMobileEnabled);
    };
  }, []);

  if (rdd.isMobile === null) {
    return <LoadingFullScreen />;
  }

  if (rdd.isMobile && !mobileWarningDismissed) {
    return <MobileDeviceMessageScreen />;
  }

  return <>{children}</>;
}
